(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mm-card-add]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    const card = trigger.closest('product-card, .product-card');
    const quickAdd = card?.querySelector('quick-add-component');
    if (!quickAdd) {
      const link = card?.querySelector('a[href*="/products/"]');
      if (link) window.location.href = link.href;
      return;
    }
    const mode = quickAdd.dataset.quickAddButton === 'add' ? 'add' : 'choose';
    quickAdd.querySelector(`.quick-add__button--${mode}`)?.click();
  });
  } catch(e) { console.error(e); }
})();

})();
